import RadiantV2RTokens from '../../tokens/RadiantV2_rTokens_Arbitrum.json';
export var LENDING_POOL_ADDRESSES = [{ address: '0xF4B1486DD74D07706052A33d31d7c0AAFD0659E1', chainId: 42161 }];
export var PROTOCOL_DATA_PROVIDER_ADDRESSES = [
    { address: '0x596B0cc4c5094507C50b579a662FE7e7b094A2cC', chainId: 42161 },
];
export var PRICE_ORACLE_ADDRESSES = [{ address: '0xC0cE5De939aaD880b0bdDcf9aB5750a53EDa454b', chainId: 42161 }];
export var ASSET_APY_TYPES = [
    { key: 'supplyAPY', value: 'supplyAPY' },
    { key: 'stableBorrowAPY', value: 'stableBorrowAPY' },
    { key: 'variableBorrowAPY', value: 'variableBorrowAPY' },
];
export var R_TOKENS = {
    1: [],
    10: [],
    42161: RadiantV2RTokens,
    8453: [],
    421613: [],
    11155111: [],
    5: [],
};
